module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-hours"
  }, [(_vm.isShowOptions) ? _c('label', {
    staticClass: "d-label marg-1-top"
  }, [_vm._v(_vm._s(_vm.i18n['period_hours']))]) : _vm._e(), _vm._v(" "), (_vm.isShowOptions) ? _c('DoDatePickerRange', {
    attrs: {
      "date": _vm.date,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "datesChanged": _vm.setDates
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDKSchool) ? _c('div', {
    staticClass: "do-hours__controls",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setShowLessons(!_vm.showLessons)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n['show_lessons']) + " (" + _vm._s(_vm.subjectDefaultDuration) + " min)")]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.showLessons
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "is-small": true,
      "bg-color": "#ffffff"
    }
  }) : [_c('div', {
    ref: "dropdown",
    staticClass: "do-card--overflow",
    style: ({
      'maxHeight': _vm.maxHeight
    })
  }, [(_vm.hoursGrouped.length < 1) ? _c('h3', {
    staticClass: "text-explainer marg-1-top"
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['no_schedule']) + "\n      ")]) : _c('table', {
    staticClass: "do-hours__table"
  }, [_c('tbody', [_vm._l((_vm.hoursGroupedSorted), function(parentCat) {
    return [_c('tr', {
      staticClass: "do-hours__row do-hours__row--parent"
    }, [_c('td', {
      staticClass: "do-hours__cell do-hours__cell--title"
    }, [_c('strong', [_vm._v(_vm._s(parentCat.vTitle))])]), _vm._v(" "), _c('td', {
      staticClass: "do-hours__cell do-hours__cell--value"
    }, [_c('strong', [_vm._v(_vm._s(parentCat.vHours))])]), _vm._v(" "), (_vm.showLessons) ? _c('td', {
      staticClass: "do-hours__cell do-hours__cell--lessons"
    }, [_c('strong', [_vm._v(_vm._s(parentCat.vLessons))])]) : _vm._e()]), _vm._v(" "), _vm._l((parentCat.subCategories), function(subCat) {
      return [(parentCat.subCategories.length > 1) ? _c('tr', {
        staticClass: "do-hours__row do-hours__row--sub"
      }, [_c('td', {
        staticClass: "do-hours__cell do-hours__cell--title"
      }, [_vm._v(_vm._s(subCat.vTitle))]), _vm._v(" "), _c('td', {
        staticClass: "do-hours__cell do-hours__cell--value"
      }, [_vm._v(_vm._s(subCat.vHours))]), _vm._v(" "), (_vm.showLessons) ? _c('td', {
        staticClass: "do-hours__cell do-hours__cell--lessons"
      }, [_vm._v("\n                " + _vm._s(subCat.vLessons) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((subCat.subjects), function(subject) {
        return [_c('tr', {
          staticClass: "do-hours__row do-hours__row--subject"
        }, [_c('td', {
          staticClass: "do-hours__cell do-hours__cell--title"
        }, [_vm._v(_vm._s(subject.vTitle))]), _vm._v(" "), _c('td', {
          staticClass: "do-hours__cell do-hours__cell--value"
        }, [_vm._v(_vm._s(subject.vHours))]), _vm._v(" "), (_vm.showLessons) ? _c('td', {
          staticClass: "do-hours__cell do-hours__cell--lessons"
        }, [_vm._v("\n                  " + _vm._s(subject.vLessons) + "\n                ")]) : _vm._e()])]
      })]
    })]
  })], 2)])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f73d31cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/CalculateHours.vue
// module id = 2167
// module chunks = 1